module.exports = __webpack_public_path__ + "cancel.svg?4b9715b7f14ce90a6e31f3e127346ca5";